<div class="w-full flex flex-col">

    <div class="bg-card flex flex-0 flex-col border-b p-4 dark:bg-transparent sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4 "
    >
        <div class="flex items-end w-full">
            <arrow-back></arrow-back>
            <div class="min-w-0 flex-1 ml-2">
                <!-- Breadcrumbs -->
                <div class="flex flex-wrap items-center font-medium">
                    <div>
                        <a class="whitespace-nowrap text-primary-500"
                            >Gestiones</a
                        >
                    </div>
                </div>
                <!-- Title -->
                <div class="flex justify-between items-center">
                    <div class="flex items-center">
                        <div class="mt-2">
                            <h2 class="truncate text-3xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">
                                {{titulo}}
                            </h2>  
                        </div>
                        <!-- Actions -->
                        <div class="mt-6 flex shrink-0 items-center sm:ml-4 sm:mt-0">
                            <button class="mt-6 flex shrink-0 items-center sm:ml-4 sm:mt-0" mat-flat-button [color]="'primary'" [matMenuTriggerFor]="filtro">
                                <mat-icon class="mr-2">filter_list</mat-icon>
                                Filtrar
                            </button>
                            <mat-menu #filtro="matMenu">
                                <button mat-menu-item (click)="this.getAllTareas(TREE_MONTHS_AGO, TODAYS_DEADLINE)">3 Meses</button>
                                <button mat-menu-item (click)="this.getAllTareas(SIX_MONTHS_AGO, TODAYS_DEADLINE)">6 Meses</button>
                                <button mat-menu-item (click)="this.getAllTareas(TODAYS_DATE, TODAYS_DEADLINE)">hoy</button>
                                <button mat-menu-item (click)="this.getAllTareas()">Todos</button>
                            </mat-menu>
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="flex items-center">
                        <button (click)="NuevaGestion()" color="seccondary" 
                            class="flex shrink-0 items-center sm:ml-4 sm:mt-0" 
                            mat-flat-button [color]="'primary'">
                            <mat-icon class="mr-2">add</mat-icon>
                            Nueva Gestión
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
    <div class="w-full flex flex-col px-6 mt-4">
        @if(this.totalGestiones$ | async;  as gestiones){
            <div class="grid w-full grid-cols-2 gap-2 md:gap-6 md:grid-cols-4">
                <card-contador nombre="Gestiones Completadas" 
                    [numero]="gestiones.completadas" 
                    icono="heroicons_outline:check-circle"
                    colorText="text-blue-500">
                </card-contador>
                <card-contador 
                    nombre="Gestiones en Proceso" 
                    [numero]="gestiones.otros_estados" 
                    icono="heroicons_outline:chart-pie"
                    colorText="text-red-500">
                </card-contador>
                <card-contador 
                    nombre="Ventanilla Ágil" 
                    [numero]="gestiones.ventanilla_agil" 
                    icono="heroicons_outline:user"
                    colorText="text-amber-500">
                </card-contador>
                <card-contador 
                    nombre="Otras Fuentes" 
                    [numero]="gestiones.otros" 
                    icono="heroicons_outline:envelope"
                    colorText="text-green-500">
                </card-contador>
            </div>
        }
    
        <div class="w-full h-96 bg-card mt-4 ">
            <div class="mx-4 h-80 mt-4">
                <div class="h-80 overflow-hidden overflow-y-auto overflow-x-auto ">
                   <!--Tabla gestiones-->
                   @if(this.dataSource$ | async;  as archivos){
                      <tabla-gestiones [dataSourseGestiones]="archivos.data"></tabla-gestiones>
                      <mat-paginator [length]="archivos.total" [pageSize]="pageSize" [hidePageSize]="true"></mat-paginator>
                   }
                    
                </div>
            </div>
        </div>  
    </div>      

</div>